import { NgModule } from '@angular/core';
import { SharedModule } from './../../shared/shared.module';
import { FilesUploadComponent } from './files-upload.component';
import { FilesUploadDialogComponent } from './dialog/files-upload-dialog/files-upload-dialog.component';



@NgModule({
  declarations: [
    FilesUploadComponent,
    FilesUploadDialogComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    FilesUploadComponent,
    FilesUploadDialogComponent
  ]
})
export class FilesUploadModule { }
